// Include all scripts here,
// orderer by alphabetical order
/* eslint-disable */

'use strict';

const jQuery = window.jQuery;

jQuery(function ($) {
    require('./archive-partners')();
    require('./arpej-numbers')();
    require('./archive-team')();
    require('./big-select')();
    require('./card-residence')();
    require('./card-residence-new')();
    require('./facetwp')();
    require('./faq-archive')();
    require('./filter-tabs')();
    require('./front-page')();
    require('./gutenberg')();
    require('./header')();
    require('./menu-mobile')();
    require('./nice-scroll')();
    require('./page-form')();
    require('./page-arpej')();
    require('./page-landing-rh')();
    require('./popin')();
    require('./phone-sticky')();
    require('./select2')();
    require('./single-residence')();
    require('./cookies')();
    require('./smooth-scroll')();
});
